import { render, staticRenderFns } from "./DialogDayComments.vue?vue&type=template&id=6308a348&scoped=true"
import script from "./DialogDayComments.vue?vue&type=script&lang=js"
export * from "./DialogDayComments.vue?vue&type=script&lang=js"
import style0 from "./DialogDayComments.vue?vue&type=style&index=0&id=6308a348&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6308a348",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6308a348')) {
      api.createRecord('6308a348', component.options)
    } else {
      api.reload('6308a348', component.options)
    }
    module.hot.accept("./DialogDayComments.vue?vue&type=template&id=6308a348&scoped=true", function () {
      api.rerender('6308a348', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogDayComments.vue"
export default component.exports